import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    Input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlContainer } from '@angular/forms';
import { FilterOperator } from '@wdx/clmi/clmi-swagger-gen';

export const DATE_TO_INT = [
    FilterOperator.LastXDays,
    FilterOperator.LastXHours,
    FilterOperator.NextXDays,
    FilterOperator.NextXHours,
    FilterOperator.OlderThanXDays,
];

export const INPUT_NUMBER = 'number';

@Component({
    selector: 'clmi-filter-date',
    templateUrl: './filter-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FilterDateComponent {
    private destroyRef = inject(DestroyRef);

    conditionalType: string;
    @Input() cySelector?: string;
    @Input() type: string;
    @Input() set operator(value: FilterOperator) {
        if (DATE_TO_INT.includes(value)) {
            this.clearFormControlValue(INPUT_NUMBER);
            this.conditionalType = INPUT_NUMBER;
        }

        if (!DATE_TO_INT.includes(value)) {
            this.clearFormControlValue(this.type);
            this.conditionalType = this.type;
        }
    }
    @Input() formControlObj: string | number;

    constructor(public controlContainer: ControlContainer) {
        this.controlContainer.control.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((val) => {
                if (this.conditionalType === INPUT_NUMBER) {
                    const value = +val;
                    this.controlContainer.control.setValue(
                        [Number.isNaN(value) ? null : value],
                        { emitEvent: false },
                    );
                    this.controlContainer.control.updateValueAndValidity({
                        emitEvent: false,
                    });
                }
            });
    }

    clearFormControlValue(type: string): void {
        if (this.conditionalType && this.conditionalType !== type) {
            this.controlContainer.control.setValue([null]);
            this.controlContainer.control.updateValueAndValidity();
        }
    }
}
